import waitForDependency from 'lib/waitForDependency';

export default function dtcWebPageAdapter() {
  const getDTCMetaFn = () => ({
    ...window.metadata,
    config_channel: 'dtc-web',
    layout: 'responsive',
  });

  return waitForDependency(() => window.metadata)
    .then(() => getDTCMetaFn)
    .catch(() => { throw new Error('dtc-web adapter error'); });
}
